(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.permisos.controller:RolsMainPermisosCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.permisos')
    .controller('RolsMainPermisosCtrl', RolsMainPermisosCtrl);

  function RolsMainPermisosCtrl($window, $rootScope, HelperFactory, ItecTreeTracking, TemaFactory, Notification, $scope, $q, $state, $stateParams,rolData,RolFactory) {
      var vm = this;
      vm.ctrlName = 'RolsMainPermisosCtrl';
      vm.rol=rolData.data;

      vm.children                 = [];
      vm.expandedCollection       = [];
      vm.loadChildren             = loadChildren;
      vm.treeTracking             = ItecTreeTracking.newInstance();
      vm.loadBasicTree            = loadBasicTree;
      vm.rootTreeNodeCollection   = [];
      vm.loadBasicTree();
      vm.back = back;
      vm.func= func;
      vm.errors = [];

      vm.onChangeReadTheme=onChangeReadTheme;
      vm.onChangeDeleteTheme=onChangeDeleteTheme;
      vm.onChangeEditTheme=onChangeEditTheme;
      vm.onChangeAddTheme=onChangeAddTheme;


      function loadBasicTree(){
        TemaFactory.gettemesvistesarrel(vm.rol.id).then(function(response) {
          $scope.$evalAsync(function(){
            if (response.data.temes.length > 0) {
              response.data.temes.forEach(function(elem){
                vm.rootTreeNodeCollection.push(elem);
                loadChildren(elem);
              });
            }
          });
        });
      }

      function filterNode(){
        return true;
      }

      function loadChildren(object) {
        if (object === undefined) {
          return [];
        }
        var deferred = $q.defer();
        if(object.children===null)
        {
          if (object.type === 'tema'){
            TemaFactory.getfills(object.id,vm.rol.id).then(function(response){
              $scope.$evalAsync(function(){
                object.children = response.data.temes.concat(response.data.objectes);
                angular.forEach(object.children, function(obj, index){
                  if (object.read) obj.read=object.read;
                  if (object.add) obj.add = object.add;
                  if (object.delete) obj.delete = object.delete;
                  if (object.edit) obj.edit = object.edit;
                  if (obj.type === 'vista') {
                    vm.rol.vistes.push(obj);
                  }
                });
                deferred.resolve(object.children);
              });
            });
          }
        }
        else{
            deferred.resolve(object.children);
        }
        return deferred.promise;
      }

      function onChangeReadTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.read = object.read;
            if (child.type === 'tema'){
              onChangeReadTheme(child);
            }
          });
        }
      }

 function onChangeAddTheme(object)
      {
        if (object.add){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.add = object.add;
            if (child.type === 'tema'){
              onChangeAddTheme(child);
            }
          });
        }
      }

 function onChangeDeleteTheme(object)
      {
        if (object.delete){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.delete = object.delete;
            if (child.type === 'tema'){
              onChangeDeleteTheme(child);
            }
          });
        }
      }

 function onChangeEditTheme(object)
      {
        if (object.edit){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.edit = object.edit;
            if (child.type === 'tema'){
              onChangeEditTheme(child);
            }
          });
        }
      }

      function back() {
        $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
        if ($stateParams.isNew) {
          $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
        }
        else {
          $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
        }
      }

      function func() {
        edit();
      }


      function edit() {
        $rootScope.$broadcast('$activateLoader');
        RolFactory.updateacls(vm.rol.id, vm.rol).then(function (response){
        $rootScope.$broadcast('$deactivateLoader');
        $rootScope.$broadcast('rols.main.submain.permisos', vm.rol);
        $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain.permisos'});
        }).catch(function(error){
          $rootScope.$broadcast('$deactivateLoader');
          vm.errors = Notification.processError(error);
        });
      }


 }
}());
